import React, { useState, useRef, useEffect, useContext } from "react";

//**************************Compentes PrimeReact************************************* */
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { confirmDialog } from "primereact/confirmdialog";
import { Checkbox } from "primereact/checkbox";

//****************************Componentes Creados*************************************/
import { toastShow } from "../../Services/ToastService";
import Loader from "../../Components/Loader/Loader";

//**************************** Hooks *************************************/
import { useForm } from "../../Hooks/useForm";

import { AuthContext } from "../../Context/AuthContext/AuthContext";
//********************Consultas API *************************** */
import {
  getEstadosCategoryIPS,
  getEstadosClientesIPS,
} from "../../API/Global/Estados/StatusRequest";
import {
  getCompanyCustomer,
  getHistoricoHexonerados,
  postCompany,
} from "../../API/Company/CompanyRequest";
import { getTerminosPaymentTerms } from "../../API/Global/Terminos/TerminosRequest";
import { getPaises } from "../../API/Global/Paises/PaisesRequest";
import { getCurrencyIPS } from "../../API/Global/Currency/CurrencyRequest";
import { getTiposPagoGenerales } from "../../API/Global/TiposPagoGeneral/TiposPagoGeneralRequest";
import { getCuentasBancariasTotales } from "../../../Base/API/Global/Bancos/BancosRequest";
import AutoCompleteDropdown from "../../Components/Form/AutoCompleteDropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { TabPanel, TabView } from "primereact/tabview";
import {
  CambiarStatus,
  getArchivoProveedor,
} from "../../API/Proveedores/ProveedoresRequest";
import { downloadBase64Data } from "../../Services/ArchivosService";
import AgGrid from "../../Components/Tables/AgGrid/AgGrid";

const ModalProveedores = ({
  proveedoresDialog,
  hideDialog,
  IdCustomer,
  getInfo,
}) => {
  // const [proveedoresDialog, setProveedoresDialog] = useState(false);
  const toast = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [registrosHexonerados, setRegistrosHexonerados] = useState([]);

  const [showMessages, setShowMessages] = useState({ error: false });
  const [estados, setEstados] = useState([]);
  const [estadosRevision, setEstadosRevision] = useState([]);
  const [estadosRegistros, setEstadosRegistros] = useState([]);
  const [loading, setLoading] = useState(false);
  const [terminos, setTerminos] = useState([]);
  const [paises, setPaises] = useState([]);
  const [monedas, setMonedas] = useState([]);
  const [tiposPago, setTiposPago] = useState([]);
  const [cuentasBanco, setCuentasBanco] = useState([]);
  const { values, handleInputChange, setValues, resetForm } = useForm({
    IdCustomer: -100,
    IdStatus: 1,
    RTN: "",
    CAI: "",
    CustomerName: "",
    Address: "",
    City: "",
    State: "",
    IdCountry: 0,
    // Country: 0,
    ZipCode: "",
    Tel: "",
    Email: "",
    Contact: "",
    IsVendor: 1,
    IsCustomer: 0,
    DateCreate: new Date(),
    IdCategory: 2,
    IdTerms: null,
    IdMonedaPago: null,
    IdUserEdit: null,
    IdTipoPago: null,
    IdBancoSugerido: null,
    AplicaCobroComision: false,
  });

  const { userAuth } = useContext(AuthContext);

  const categorys = [
    {
      IdCategory: 1,
      Category: "Proveedor Compras",
    },
    {
      IdCategory: 2,
      Category: "Proveedor Varios",
    },
  ];

  const obtenerInformacionDropdow = async () => {
    setLoading(true);
    const tempoEstados = await getEstadosClientesIPS();
    setEstados(tempoEstados);

    const tempoEstadosRevision = await getEstadosCategoryIPS(
      "Revision Proveedor"
    );
    setEstadosRevision(tempoEstadosRevision);

    const tempoTerminos = await getTerminosPaymentTerms();
    setTerminos(tempoTerminos);

    const tempoPaises = await getPaises();
    setPaises(tempoPaises);

    const tempoMonedas = await getCurrencyIPS();
    setMonedas(tempoMonedas);

    const tempoTipoPago = await getTiposPagoGenerales();
    setTiposPago(tempoTipoPago);

    const tempoCuentaBanco = await getCuentasBancariasTotales();
    setCuentasBanco(tempoCuentaBanco);

    // 2. Si hay cliente, cargar valores asociados
    if (IdCustomer > 0) {
      const [company] = await getCompanyCustomer(IdCustomer);

      const historicosTempo = await getHistoricoHexonerados(IdCustomer);
      setRegistrosHexonerados(historicosTempo);

      const tempoEstadosRegistro = await getEstadosCategoryIPS("Registro Exonerado");
      setEstadosRegistros(tempoEstadosRegistro);
      setValues({
        ...company,
        Estado: tempoEstados.find((e) => e.IdStatus === company?.IdStatus),
        EstadoRevision: tempoEstadosRevision.find(
          (e) => e.IdStatus === company?.IdStatusRevision
        ),
        Categoria: categorys.find((c) => c.IdCategory === company?.IdCategory),
        Pais: tempoPaises.find((p) => p.Id === company?.IdCountry),
        Termino: tempoTerminos.find((t) => t.IdTerm === company?.IdTerms),
        Moneda: tempoMonedas.find((m) => m.IdCurrency === company?.IdCurrency),
        MonedaPago: tempoMonedas.find((mp)=> mp.IdCurrency === company?.IdMonedaPago),
        TipoPago: tempoTipoPago.find(
          (t) => t.IdTipoPago === company?.IdTipoPago
        ),
        CuentaBanco: tempoCuentaBanco.find(
          (c) => c.IdCuenta === company?.IdBancoSugerido
        ),
      });
    } else {
      setValues((prev) => ({
        ...prev,
        Estado: tempoEstados.find((e) => e.IdStatus === 1),
        EstadoRevision: tempoEstadosRevision.find((e) => e.IdStatus === 3722),
      }));
    }
    setLoading(false);
  };

  const cambiarPais = (e) => {
    const pais = e?.target?.value;

    if (!pais || !pais.Id) {
      setValues((prev) => ({
        ...prev,
        IdCountry: 0,
        Country: "",
        Pais: null,
      }));
    } else {
      setValues((prev) => ({
        ...prev,
        IdCountry: pais.Id,
        Country: pais.Name,
        Pais: pais,
      }));
    }
  };

  const verificarCampos = () => {
    let errors = {};
    let isValid = true;
    if (!values.CustomerName) {
      errors.CustomerName = true;
      errors.General = true;
      isValid = false;
    }

    if (!values.Estado || !values.Estado.IdStatus) {
      errors.IdStatus = true;
      errors.General = true;
      isValid = false;
    }

    if (!values?.Pais?.Id) {
      errors.IdCountry = true;
      errors.General = true;
      isValid = false;
    }

    // if(!values.IdMonedaPago){
    //     errors.IdMonedaPago = true
    //     errors.General = true
    //     isValid = false
    // }

    setShowMessages({ ...errors, error: !isValid });
    if (Object.keys(errors).length === 0 && isValid) {
      return false;
    } else {
      console.log(errors, values);
      return true;
    }
  };

  const guardarInformacionProveedor = () => {
    const verificar = verificarCampos();
    if (verificar) {
      toastShow(toast, "error", "Llenar los campos requeridos");
      return;
    } else {
      let message = (
        <div>¿Está seguro que desea guardar la información del Proveedor?</div>
      );

      confirmDialog({
        message: message,
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        accept: async () => {
          let dataEnviar = {
            ...values,
            UsuarioWeb: userAuth.idUser,
            NombreComercial: values?.NombreComercial,
            IdCategory: values?.Categoria?.IdCategory,
            IdStatus: values?.Estado?.IdStatus,
            IdCountry: values?.Pais?.Id,
            Country: values?.Pais?.Name,
            IdTerms: values?.Termino?.IdTerm,
            IdMonedaPago: values?.MonedaPago?.IdCurrency,
            IdTipoPago: values?.TipoPago?.IdTipoPago,
            IdBancoSugerido: values?.CuentaBanco?.IdCuenta,
            IdStatusRevision: values?.EstadoRevision?.IdStatus,
          };
         

          const result = await postCompany(dataEnviar);
          if (result) {
            if (result[0]?.ERROR === -1) {
              toastShow(toast, "error", result[0]?.MSJ);
            }
            if (result[0]?.ERROR === 0) {
              toastShow(toast, "success", result[0]?.MSJ);
              setTimeout(() => {
                getInfo();
                hideDialog();
              }, 2000);
            }

            if (result[0]?.ERROR === -10) {
              toastShow(toast, "error", result[0]?.MSJ);
            }
          }
        },
        reject: () => {
          toastShow(toast, "warn", "Actualización cancelada");
        },
      });
    }
  };

  const changeEstado = ({ data, api }) => {
    return (
      <div>
        <Dropdown
          value={
            estadosRegistros.filter((e) => e.IdStatus === data.IdEstado)[0]
          }
          options={estadosRegistros}
          optionLabel="StatusName"
          filter
          disabled={![1, 8, 17].includes(userAuth?.IdRol) || data?.IdEstado === 3727}
          filterBy="StatusName"
          style={{ width: "100%" }}
          onChange={(e) => {
            confirmDialog({
              message: `¿Cambiar a estado ${e.value.StatusName}?`,
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              accept: async () => {
                const index = registrosHexonerados.findIndex(
                  (detail) => detail.IdRegistro === data.IdRegistro
                );
                let newDetail = [...registrosHexonerados];
                newDetail[index].IdStatus = e.value.IdStatus;
                newDetail[index].StatusName = e.value.StatusName;
                CambiarStatus(e.value.IdStatus, data.IdRegistro);
                setRegistrosHexonerados(newDetail);
                obtenerInformacionDropdow();
                api.stopEditing();
              },
              reject: () => {
                obtenerInformacionDropdow();
              },
            });
          }}
        />
      </div>
    );
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDialog}
      />
      {activeIndex === 0 && (
        <Button
          label="Guardar"
          icon="pi pi-check"
          className="p-button-text"
          onClick={() => guardarInformacionProveedor()}
          loading={loading}
        />
      )}
    </React.Fragment>
  );

  const columnBands = [
    {
      field: "IdRegistro",
      header: "ID",
      className: "XXsmall",
      hidden: userAuth?.IdRol === 1,
      frozen: "frozen",
    },
    {
      field: "StatusName",
      header: "Estado",
      headerEn: "Status",
      className: "small",
      filter: true,
      cellEditor: changeEstado,
      body: (rowData) => ({
        ID: rowData.IdEstado,
        Estado: rowData.StatusName,
      }),
      Format: "Estado",
      editable: true,
    },
    {
      field: "RegistroExonerado",
      header: "Registro",
      headerEn: "Record",
      className: "large",
      Flex: 1,
      minWidth: 300
    },
    {
      field: 'StartDate',
      header: 'Fecha Inicio',
      headerEn: 'Start Date',
      className: "small",
      filter: true,
      Format: "Datetime",
    },
    {
      field: "FechaVencimientoStr",
      header: "Fecha Vencimiento",
      headerEn: "Date Expired",
      className: "small",
      filter: true,
      Format: "Datetime",
    },
    {
      field: "UserName",
      header: "Usuario Reviso",
      headerEn: "User Review",
      className: "large",
    },
    {
      field: "DateRevisoStr",
      header: "Fecha Revisión",
      headerEn: "Date Expired",
      className: "small",
      filter: true,
      Format: "Datetime",
    },
    {
      // RegistroExonerado
      field: "RegistroExoneradoArchivo",
      header: "Registro Exonerado",
      className: "colum-width-small",
      body: (rowData) =>
        botonDonwload(
          "getRegistroExoneradoFile",
          rowData.RegistroExoneradoName,
          rowData.IdProveedor,
          rowData.RegistroExoneradoName
        ),
      Format: "Template",
      filter: false
    },
    {
      field: "FileConstPagosCuenta",
      header: "Const. Pagos Cuenta",
      className: "colum-width-small",
      body: (rowData) =>
        botonDonwload(
          "getConstanciaPagosFile",
          rowData.RegistroExoneradoName,
          rowData.IdProveedor,
          rowData.ConstPagosName
        ),
      Format: "Template",
      filter: false
    },
  ];

  const table = {
    Columns: columnBands,
    Data: registrosHexonerados,
    key: "IdRegistro",
    scrollHeight: "100%"
  };

  const botonDonwload = (File, tooltip, IdCustomer, FileName) => {
    if (IdCustomer) {
      return (
        <div
          className="col-12 d-flex align-items-center"
          style={{ textAlign: "center" }}
        >
          <Button
            className="p-button-outlined p-button-text mx-3"
            icon="pi pi-download"
            tooltip={tooltip}
            tooltipOptions={{ position: "left" }}
            disabled={FileName === null}
            onClick={() => {
              getFile(File, IdCustomer);
            }}
            style={{ padding: "0" }}
          />
        </div>
      );
    } else {
      return null;
    }
  };

  const getFile = async (file, IdCustomer) => {
    const File = await getArchivoProveedor(file, IdCustomer);
    if (File.length > 0) {
      downloadBase64Data({ Data: File[0]?.Archivo, Tipo: File[0]?.Name });
    }
  };

  useEffect(() => {
    if (proveedoresDialog) {
      obtenerInformacionDropdow();
    } else {
      resetForm({});
      setShowMessages({ error: false });
    }
  }, [proveedoresDialog, activeIndex]);

  useEffect(() => {
    setActiveIndex(0);
  }, [proveedoresDialog]);

  const title = IdCustomer > 0 ? "Editar Proveedor" : "Agregar Proveedor";

  return (
    <div>
      <Dialog
        visible={proveedoresDialog}
        footer={DialogFooter}
        onHide={hideDialog}
        header={<h3>{title}</h3>}
        style={{ width: "60%", margin: "auto" }}
      >
        {/* <ConfirmDialog /> */}
        <Toast ref={toast} />
        <div id="ProveedorIPS">
          <Loader loading={loading} querySelector="#ProveedorIPS" />

          <TabView
            className="col-12 homeTabView"
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
          >
            <TabPanel header="Información General">
              <div>
                <div className="modal__input-contenedor3 gap-2">
                  <div className="field col-3">
                    <span className="p-float-label">
                      <InputText
                        value={values.CustomerName}
                        onChange={(e) => handleInputChange(e, "CustomerName")}
                        style={{ width: "100%" }}
                        className={classNames({
                          "p-invalid": showMessages?.CustomerName,
                        })}
                      />
                      <label htmlFor="CustomerName">Nombre Legal</label>
                    </span>
                  </div>

                  <div className="field col-3">
                    <span className="p-float-label">
                      <InputText
                        value={values?.NombreComercial}
                        onChange={(e) =>
                          handleInputChange(e, "NombreComercial")
                        }
                        style={{ width: "100%" }}
                        className={classNames({
                          "p-invalid": showMessages?.NombreComercial,
                        })}
                      />
                      <label htmlFor="NombreComercial">Nombre Comercial</label>
                    </span>
                  </div>

                  <div className="field col-3">
                    <span className="p-float-label">
                      <InputText
                        value={values.RTN}
                        onChange={(e) => handleInputChange(e, "RTN")}
                        className={classNames({
                          "p-invalid": showMessages?.RTN,
                        })}
                        style={{ width: "100%" }}
                      />
                      <label htmlFor="RTN">RTN</label>
                    </span>
                  </div>

                  <div className="field col-3">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"Categoria"}
                        value={values.Categoria}
                        items={categorys}
                        field={"Category"}
                        label={"Categoría"}
                        handleInputChange={handleInputChange}
                        labelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                        className={classNames({
                          "p-invalid": showMessages?.IdCategory,
                        })}
                      />
                    </span>
                  </div>
                </div>

                <div className="modal__input-contenedor3 gap-2">
                  <div className="field col-3">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"Pais"}
                        value={values.Pais}
                        items={paises}
                        field={"Name"}
                        label={"Name"}
                        // handleInputChange={cambiarPais}
                        handleInputChange={handleInputChange}
                        labelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                        className={classNames({
                          "p-invalid": showMessages?.IdCountry,
                        })}
                      />
                    </span>
                  </div>

                  <div className="field col-3">
                    <span className="p-float-label">
                      <InputText
                        value={values.State}
                        onChange={(e) => handleInputChange(e, "State")}
                        style={{ width: "100%" }}
                        className={classNames({
                          "p-invalid": showMessages?.State,
                        })}
                      />
                      <label htmlFor="State">Estado / Depto</label>
                    </span>
                  </div>

                  <div className="field col-3">
                    <span className="p-float-label">
                      <InputText
                        value={values.City}
                        onChange={(e) => handleInputChange(e, "City")}
                        style={{ width: "100%" }}
                        className={classNames({
                          "p-invalid": showMessages?.City,
                        })}
                      />
                      <label htmlFor="City">Ciudad</label>
                    </span>
                  </div>

                  <div className="field col-3">
                    <span className="p-float-label">
                      <InputTextarea
                        value={values.Address}
                        onChange={(e) => handleInputChange(e, "Address")}
                        style={{ width: "100%" }}
                        rows={1}
                        className={classNames({
                          "p-invalid": showMessages?.Address,
                        })}
                      />
                      <label htmlFor="Address">Dirección</label>
                    </span>
                  </div>
                </div>

                <div className="modal__input-contenedor3 gap-2">
                  <div className="field col-3">
                    <span className="p-float-label">
                      <InputText
                        value={values?.Tel}
                        onChange={(e) => handleInputChange(e, "Tel")}
                        style={{ width: "100%" }}
                        className={classNames({
                          "p-invalid": showMessages?.Tel,
                        })}
                      />
                      <label htmlFor="Tel">Telefono</label>
                    </span>
                  </div>

                  <div className="field col-3">
                    <span className="p-float-label">
                      <InputText
                        value={values.Email}
                        onChange={(e) => handleInputChange(e, "Email")}
                        className={classNames({
                          "p-invalid": showMessages?.Email,
                        })}
                        style={{ width: "100%" }}
                      />
                      <label htmlFor="Email">Email</label>
                    </span>
                  </div>

                  <div className="field col-3">
                    <span className="p-float-label">
                      <InputText
                        value={values.Contact}
                        onChange={(e) => handleInputChange(e, "Contact")}
                        className={classNames({
                          "p-invalid": showMessages?.Contact,
                        })}
                        style={{ width: "100%" }}
                      />
                      <label htmlFor="Contact">Contacto</label>
                    </span>
                  </div>

                  <div className="field col-3">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"Termino"}
                        value={values?.Termino}
                        items={terminos}
                        field={"TermName"}
                        label={"Términos"}
                        handleInputChange={handleInputChange}
                        labelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                        className={classNames({
                          "p-invalid": showMessages?.IdTerms,
                        })}
                      />
                    </span>
                  </div>
                </div>

                {/* Visible solo para rol Sistemas y Finanzas */}
                {[1, 17].includes(userAuth?.IdRol) && (
                  <div className="modal__input-contenedor3 gap-2">
                    <div className="field col-3">
                      <span className="p-float-label">
                        <AutoCompleteDropdown
                          name={"MonedaPago"}
                          value={values?.MonedaPago}
                          items={monedas}
                          field={"Currency"}
                          label={"Moneda Pago"}
                          handleInputChange={handleInputChange}
                          labelStyle={{
                            color: "gray",
                            textShadow: "0px 0px 1px white",
                          }}
                          className={classNames({
                            "p-invalid": showMessages?.IdTerms,
                          })}
                        />
                      </span>
                    </div>

                    <div className="field col-3">
                      <span className="p-float-label">
                        <AutoCompleteDropdown
                          name={"TipoPago"}
                          value={values?.TipoPago}
                          items={tiposPago}
                          field={"TipoPago"}
                          label={"Tipo Pago"}
                          handleInputChange={handleInputChange}
                          labelStyle={{
                            color: "gray",
                            textShadow: "0px 0px 1px white",
                          }}
                          className={classNames({
                            "p-invalid": showMessages?.IdTerms,
                          })}
                        />
                      </span>
                    </div>

                    <div className="field col-3">
                      <span className="p-float-label">
                        <AutoCompleteDropdown
                          name={"CuentaBanco"}
                          value={values?.CuentaBanco}
                          items={cuentasBanco}
                          field={"Cuenta"}
                          label={"Banco"}
                          handleInputChange={handleInputChange}
                          labelStyle={{
                            color: "gray",
                            textShadow: "0px 0px 1px white",
                          }}
                          className={classNames({
                            "p-invalid": showMessages?.IdTerms,
                          })}
                        />
                      </span>
                    </div>

                    <div className="field col-3">
                      <div className="d-flex gap mt-4">
                        <Checkbox
                          checked={values.AplicaCobroComision}
                          onChange={(e) =>
                            handleInputChange(e, "AplicaCobroComision")
                          }
                        />
                        <label> Aplica Cobro Comisión</label>
                      </div>
                    </div>
                  </div>
                )}

                <div className="modal__input-contenedor3 gap-2">
                  <div className="field col-3">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"EstadoRevision"}
                        value={values.EstadoRevision}
                        items={estadosRevision}
                        field={"StatusName"}
                        label={"Revisión"}
                        handleInputChange={handleInputChange}
                        labelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                      />
                    </span>
                  </div>

                  <div className="field col-3">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"Estado"}
                        value={values.Estado}
                        items={estados}
                        field={"StatusName"}
                        label={"Estado"}
                        enable={
                          [2, 3].includes(values.Estado?.IdStatus)
                            ? false
                            : true
                        }
                        handleInputChange={handleInputChange}
                        labelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                        className={classNames({
                          "p-invalid": showMessages?.IdStatus,
                        })}
                      />
                    </span>
                  </div>

                  <div className="field col-3">
                    <div className="d-flex gap mt-4">
                      <Checkbox
                        checked={values?.ProveedorExterior}
                        onChange={(e) =>
                          handleInputChange(e, "ProveedorExterior")
                        }
                      />
                      <label>Proveedor Exterior</label>
                    </div>
                  </div>

                  <div className="field col-3" style={{ display: "none" }}>
                    <span className="p-float-label">
                      <InputText
                        value={values.Country}
                        onChange={(e) => handleInputChange(e, "Country")}
                        style={{ width: "100%" }}
                        className={classNames({
                          "p-invalid": showMessages?.Country,
                        })}
                      />
                      <label htmlFor="Country">Pais</label>
                    </span>
                  </div>
                </div>
              </div>
            </TabPanel>
            {IdCustomer > 0 && (
              <TabPanel header="Registro exonerado">
                <div style={{ height: "37vh" }}>
                  <AgGrid table={table} />
                </div>
              </TabPanel>
            )}
          </TabView>
        </div>
      </Dialog>
    </div>
  );
};

export default ModalProveedores;